import React from "react";
import { createRoot } from "react-dom/client";
import CartPage from "./component/CartPage";

export default () => {
  const dom = document.querySelector('[data-cart-page]');
  if (dom) {
    const cartRoot = createRoot(dom);
    cartRoot.render(
      <CartPage
        event={dom.getAttribute('data-event')}
        submit={dom.getAttribute('data-submit')}
        base_url={dom.getAttribute('data-base-url')} />
    );
  }
};
